
import {defer} from "@e280/stz"
import {Identity} from "../types.js"
import {Context} from "../context.js"
import {Payload} from "../../lib/core/tok/types.js"
import {Proof} from "../../lib/core/alco/proof/types.js"
import {seedId} from "../../lib/core/ergo/seed/seed-id.js"
import {DelegatorApi} from "../../lib/protocol/parts/types.js"
import {decodeToken} from "../../lib/core/tok/decode-token.js"
import {secretize} from "../../lib/core/ergo/seed/secretize.js"
import {signDelegate} from "../../lib/core/alco/delegate/sign.js"

export const delegatorApi = (context: Context, delegatorOrigin: string) => (
	(appOrigin: string) => (<DelegatorApi>{v1: {
		async requestDelegates(petitions) {
			const chooseIdentity = defer<Identity>()

			context.$expedition({
				appOrigin,
				petitions,
				chooseIdentity: chooseIdentity.resolve,
			})

			const identity = await chooseIdentity.promise
			const atTime = Date.now()

			const delegates = petitions.map(petition =>
				signDelegate(secretize(identity.seed), {
					alias: identity.alias,
					petition,
					issuer: delegatorOrigin,
					audience: appOrigin,
					atTime,
				})
			)

			await context.bank.recordDelegationEvent({
				id: seedId(identity.seed),
				alias: identity.alias,
				app: appOrigin,
				time: atTime,
				proofPayloads: delegates.map(
					d => decodeToken<Payload<{proof: Proof}>>(d.proofToken).payload
				),
			})

			return delegates
		},
	}})
)

